import AppBar from '@material-ui/core/AppBar';
import CssBaseline from '@material-ui/core/CssBaseline';
import Divider from '@material-ui/core/Divider';
import Drawer from '@material-ui/core/Drawer';
import IconButton from '@material-ui/core/IconButton';
import MenuItem from '@material-ui/core/MenuItem';
import { makeStyles } from '@material-ui/core/styles';
import { fade } from '@material-ui/core/styles/colorManipulator';
import Toolbar from '@material-ui/core/Toolbar';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import AccountCircle from '@material-ui/icons/AccountCircle';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import MenuIcon from '@material-ui/icons/Menu';
import clsx from 'clsx';
import moment from 'moment';
import 'moment/locale/el';
import { useRouter } from 'next/router';
import React, { useContext, useEffect, useState, useCallback } from 'react';
import { isBrowser, isMobileOnly, isTablet } from 'react-device-detect';
import { lastSync } from '../../src/requests/client/lastSync';
import UserContext from '../../src/UserContext';
import Copyright from '../assets/Copyright';
import SideBar from './SideBar';
import useResizeObserver from '../assets/useResizeObserver';

const drawerWidth = 240;
const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    height: 64,
    ...theme.mixins.toolbar,
  },
  toolbarIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
  content: {
    flexGrow: 1,
    minHeight: '100vh',
    display: 'grid',
    gridTemplateRows: 'auto 1fr auto',
  },
  appBar: {
    position: 'fixed',
    width: '100%',
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    position: 'fixed',
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  menuButtonHidden: {
    display: 'none',
  },
  title: {
    display: 'none',
    [theme.breakpoints.up('sm')]: {
      display: 'block',
    },
  },
  dataCaption: {
    display: 'none',
    [theme.breakpoints.up('sm')]: {
      display: 'block',
    },
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: theme.spacing(7) + 1,
  },
  appBarSpacer: theme.mixins.toolbar,
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  inputRoot: {
    color: 'inherit',
  },
  icons: {
    flexGrow: 1,
  },
}));

function getUserType(keycloakState) {
  if (
    keycloakState?.authenticated === true &&
    (JSON.parse(sessionStorage.getItem('userSession'))?.isAdmin ||
      JSON.parse(sessionStorage.getItem('userSession'))?.isChamberUser)
  ) {
    return 'authenticated';
  } else {
    return 'notauthenticated';
  }
}

export default function AppSideBar({ children }) {
  const classes = useStyles();
  const [AnchorE1, setAnchorEl] = React.useState(null);
  const [open, setOpen] = React.useState(true);
  const inputValue = ' ';
  const router = useRouter();
  let { keycloakstate, setKeycloakstate } = useContext(UserContext);

  const [lastSyncDate, setLastSyncDate] = useState();
  const [ref, { contentRect }] = useResizeObserver();

  const getContentRect = useCallback(
    (key) => contentRect && Math.round(contentRect[key]),
    [contentRect]
  );

  useEffect(async () => {
    let date = await lastSync();
    setLastSyncDate(date.lastrun);
  }, []);

  const logout = async () => {
    sessionStorage.removeItem('authentication');
    sessionStorage.removeItem('refreshToken');
    sessionStorage.removeItem('userSession');
    sessionStorage.removeItem('roles');
    var currentURL = window.location.protocol + '//' + window.location.host;
    const keycloakJson = (
      await import(`../../public/keycloak/${process.env.keycloak}`)
    ).default;
    window.location =
      keycloakJson['auth-server-url'] +
      '/realms/' +
      keycloakJson['realm'] +
      '/protocol/openid-connect/logout?redirect_uri=' +
      currentURL;
  };

  useEffect(() => {
    isBrowser ? setOpen(true) : setOpen(false);
  }, []);

  const handleDrawerOpen = () => {
    setOpen(true);
  };
  const handleDrawerClose = () => {
    setOpen(false);
  };

  const handleProfileMenuOpen = async (event) => {
    const token = await localStorage.removeItem('token');
    // await router.push("/");

    setAnchorEl(event.currentTarget);
  };

  const menuId = 'primary-search-account-menu';

  return (
    <div className={classes.root} id='root-app-bar' ref={ref}>
      <CssBaseline />
      <AppBar
        id='app-bar'
        position='absolute'
        color='primary'
        className={clsx(classes.appBar, open && classes.appBarShift)}
      >
        <Toolbar className={classes.toolbar}>
          <IconButton
            edge='start'
            color='inherit'
            aria-label='open drawer'
            onClick={handleDrawerOpen}
            className={clsx(
              classes.menuButton,
              open && classes.menuButtonHidden
            )}
          >
            <MenuIcon />
          </IconButton>
          <Typography
            component='h1'
            variant='h6'
            color='inherit'
            noWrap
            className={classes.title}
          >
            Στατιστική Ανάλυση Επιχειρηματικότητας
          </Typography>
          <div id='icons' className={classes.icons}></div>
          {keycloakstate?.authenticated === true ? (
            <>
              {!isMobileOnly && !isTablet ? (
                <>
                  <Typography
                    color='inherit'
                    noWrap
                    className={classes.dataCaption}
                  >
                    Δεδομένα μέχρι και
                    <i>
                      {' '.concat(moment(lastSyncDate).format('dddd, LL, LTS'))}
                    </i>
                  </Typography>
                </>
              ) : isTablet ? (
                <Typography
                  color='inherit'
                  noWrap
                  className={classes.dataCaption}
                >
                  Δεδομένα μέχρι και
                  <i>
                    {' '.concat(moment(lastSyncDate).format('DD/MM/YYYY, LTS'))}
                  </i>
                </Typography>
              ) : (
                <></>
              )}
              <MenuItem onClick={handleProfileMenuOpen}>
                <IconButton
                  aria-label='account of current user'
                  aria-controls='primary-search-account-menu'
                  aria-haspopup='true'
                  className={classes.iconButton}
                >
                  <AccountCircle />
                </IconButton>
                {keycloakstate?.userName}
              </MenuItem>
              <Tooltip
                title='Έξοδος από την εφαρμογή'
                placement='top-start'
                arrow
              >
                <IconButton
                  edge='end'
                  aria-label='account of current user'
                  aria-controls={menuId}
                  aria-haspopup='true'
                  onClick={logout}
                  color='inherit'
                >
                  <ExitToAppIcon />
                </IconButton>
              </Tooltip>
            </>
          ) : (
            <MenuItem onClick={() => router.push('/login')}>
              <IconButton
                aria-label='Σύνδεση/Εγγραφή'
                className={classes.iconButton}
              >
                <ExitToAppIcon />
              </IconButton>
              <p>Σύνδεση/Εγγραφή</p>
            </MenuItem>
          )}
        </Toolbar>
      </AppBar>
      {getContentRect('width') > 800 ? (
        <Drawer
          variant='permanent'
          className={clsx(classes.drawer, {
            [classes.drawerOpen]: open,
            [classes.drawerClose]: !open,
          })}
          classes={{
            paper: clsx({
              [classes.drawerOpen]: open,
              [classes.drawerClose]: !open,
            }),
          }}
          open={open}
        >
          <div className={classes.toolbarIcon}>
            <IconButton onClick={handleDrawerClose}>
              <ChevronLeftIcon />
            </IconButton>
          </div>
          <Divider />
          {getUserType(keycloakstate) == 'authenticated' ? (
            <SideBar openSideBar={open} />
          ) : null}
        </Drawer>
      ) : (
        <Drawer
          className={clsx(classes.drawer, {
            [classes.drawerOpen]: open,
            [classes.drawerClose]: !open,
          })}
          classes={{
            paper: clsx({
              [classes.drawerOpen]: open,
              [classes.drawerClose]: !open,
            }),
          }}
          open={open}
        >
          <div className={classes.toolbarIcon}>
            <IconButton onClick={handleDrawerClose}>
              <ChevronLeftIcon />
            </IconButton>
          </div>
          <Divider />
          {getUserType(keycloakstate) == 'authenticated' ? (
            <SideBar openSideBar={open} />
          ) : null}
        </Drawer>
      )}
      <main id='right-content' className={classes.content}>
        <div id='toolbar' className={classes.toolbar} />
        <div id='content'>{children}</div>
        {isMobileOnly ? (
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Typography color='inherit' noWrap>
              Δεδομένα μέχρι και
              <i>
                {' '.concat(moment(lastSyncDate).format('DD/MM/YYYY, LTS'))}
              </i>
            </Typography>
          </div>
        ) : (
          <></>
        )}
        <Copyright />
      </main>
    </div>
  );
}
